import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function PerformanceFilters({ range, onChange }) {
  return (
    <div className="flex flex-wrap gap-3 mb-4" data-testid="performance-filters">
      <div>
        <Label htmlFor="perf-start">From</Label>
        <Input
          id="perf-start"
          type="date"
          value={range.start}
          onChange={(e) => onChange({ ...range, start: e.target.value })}
          data-testid="performance-start-date-input"
          className="mt-1.5 h-10"
        />
      </div>
      <div>
        <Label htmlFor="perf-end">To</Label>
        <Input
          id="perf-end"
          type="date"
          value={range.end}
          onChange={(e) => onChange({ ...range, end: e.target.value })}
          data-testid="performance-end-date-input"
          className="mt-1.5 h-10"
        />
      </div>
      <div>
        <Label htmlFor="perf-campaign">Campaign</Label>
        <select
          id="perf-campaign"
          value={range.campaign || ""}
          onChange={(e) => onChange({ ...range, campaign: e.target.value })}
          data-testid="performance-campaign-filter"
          className="mt-1.5 h-10 rounded-md border border-input bg-background px-3 text-sm block"
        >
          <option value="">All campaigns</option>
          <option value="diwali2026">Diwali 2026</option>
        </select>
      </div>
    </div>
  );
}
